export default __webpack_public_path__ + "static/media/bg7.c29bc004.jpg";